import { Modal } from "antd";
import { Formik } from "formik";
import Eye from "../../components/Eye";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import React, { useEffect, useState } from "react";
import { pageRoutes } from "../../routes/pageRoutes";
import { pipGetTeamDirectory } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import { fetchBotDirectory } from "../../redux/action/moreAction";
import LocationDropdown from "../../components/country-state-city";
import { fetchleagueTournaments } from "../../redux/action/getStartAction";

import {
  signInSchema,
  signUpSchema,
  basicDetailSchema,
} from "../../utils/schema";
import {
  authLogin,
  authRegister,
  authUpdateMemberDetails,
  fetchWeightClassCategories,
} from "../../redux/action/authAction";

const MemberLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = pipGetTeamDirectory();
  const [isEye, setIsEye] = useState(false);
  const [isEye1, setIsEye1] = useState(false);
  const [isEye2, setIsEye2] = useState(false);
  const [isEye3, setIsEye3] = useState(false);
  const [isEye4, setIsEye4] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [weight_class_id, setWeight_class_id] = useState(
    user?.weight_class_id ?? null
  );
  const [selectedLocation, setSelectedLocation] = useState({
    country: user?.country ?? "",
    state: user?.state ?? "",
    city: user?.city ?? "",
  });
  const [bot_id, setBot_id] = useState(user?.bot?.id ?? null);
  const { botList } = useSelector((state) => state.moreReducer);

  const { isLoading, weightClassCategories } = useSelector(
    (state) => state.authReducer
  );

  const filteredBotList = botList?.filter(
    (item) => item?.created_by?.id == user?.id
  );

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
  };

  // login form initial state
  const initialState = {
    email: "",
    password: "",
  };
  // sign up form initial state
  const initialState1 = {
    name: "",
    email: "",
    number: "",
    password: "",
    confirm_password: "",
  };
  // team member detail form initial state
  const initialState2 = {
    name: "",
    email: "",
    about: "",
    number: "",
    password: "",
    tournament: "",
    designation: "",
    website_link: "",
    discord_name: "",
    profile_image: "",
    confirm_password: "",
  };

  useEffect(() => {
    dispatch(fetchBotDirectory());
    dispatch(fetchleagueTournaments());
    dispatch(fetchWeightClassCategories());
  }, []);

  const toggleSignUp = () => setIsSignUp(!isSignUp);

  // login
  const handleLogin = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        if (response?.data?.user?.is_popup_display != 0) {
          setIsModalOpen(true);
        } else {
          navigate(pageRoutes.more?.teamDirectory);
        }
      }
    };
    dispatch(authLogin({ payload: values, callback }));
  };
  // Sign up
  const handleSignUp = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        toggleSignUp();
      }
    };
    dispatch(authRegister({ payload: values, callback }));
  };
  // update member detail
  const handleUpdateMemberDetails = (values) => {
    const data = {
      ...values,
      bot_id,
      weight_class_id,
      user_id: user?.id,
      ...selectedLocation,
    };
    const formdata = new FormData();

    // Append all key-value pairs from data
    Object.entries(data).forEach(([key, value]) => {
      if (value instanceof File) {
        formdata.append(key, value); // Append file directly
      } else {
        formdata.append(key, value ?? ""); // Ensure empty values are handled properly
      }
    });

    const callback = (response) => {
      if (response.success) {
        const { user, token } = pipGetTeamDirectory();

        localStorage.setItem(
          "Team-Member-Detail",
          JSON.stringify({
            token,
            user: { ...user, ...response?.data },
          })
        );
        navigate(pageRoutes.more?.teamDirectory);
        setIsModalOpen(false);
      }
    };
    dispatch(authUpdateMemberDetails({ payload: formdata, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="ct_login_bg">
        <div
          className={`ct_login_main ${isSignUp ? "right-panel-active" : ""}`}
          id="ct_login_main"
        >
          {/* Sign Up */}
          <div
            className="form-container sign-up-container"
            style={{ display: isSignUp ? "block" : "none" }}
          >
            <Formik
              initialValues={initialState1}
              validationSchema={signUpSchema}
              onSubmit={(values, actions) => {
                handleSignUp(values, actions);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => (
                <form>
                  <div className="mb-4">
                    <a
                      className="navbar-brand ct_logo_text "
                      href="javascript:void(0)"
                      onClick={() => navigate(-1)}
                    >
                      <i className="fa-solid fa-arrow-left"></i> Back
                    </a>
                  </div>
                  <h1 className="mb-5">Sign up your combat robotics team</h1>
                  <div className="ct_input-group mb-3">
                    <input
                      required
                      type="text"
                      id="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      autoComplete="off"
                      className="ct_input"
                    />
                    <label className="ct_user-label">
                      Team Name{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="name"
                    />
                  </div>
                  <div className="ct_input-group mb-3">
                    <input
                      required
                      type="text"
                      autoComplete="off"
                      className="ct_input"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <label className="ct_user-label">
                      Email{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="email"
                    />
                  </div>
                  <div className="ct_input-group mb-3">
                    <input
                      required
                      type="text"
                      name="number"
                      autoComplete="off"
                      className="ct_input"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.number}
                      onWheel={(e) => e.target.blur()}
                      pattern="[0-9]*"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                      }}
                    />
                    <label className="ct_user-label">Number</label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="number"
                    />
                  </div>
                  <div className="ct_input-group mb-3 position-relative">
                    <input
                      required
                      type={!isEye1 ? "password" : "text"}
                      name="password"
                      autoComplete="off"
                      className="ct_input"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    <Eye
                      isEye={isEye1}
                      onClick={setIsEye1}
                      style={{ top: "20px" }}
                    />
                    <label className="ct_user-label">
                      Password{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="password"
                    />
                  </div>
                  <div className="ct_input-group mb-3 position-relative">
                    <input
                      required
                      type={!isEye2 ? "password" : "text"}
                      name="confirm_password"
                      autoComplete="off"
                      className="ct_input"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirm_password}
                    />
                    <Eye
                      isEye={isEye2}
                      onClick={setIsEye2}
                      style={{ top: "20px" }}
                    />
                    <label className="ct_user-label">
                      Confirm Password{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="confirm_password"
                    />
                  </div>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-secondary ct_btn_animate w-100"
                  >
                    Sign Up
                  </button>
                </form>
              )}
            </Formik>
          </div>
          {/* Sign In */}
          <div
            className="form-container sign-in-container"
            style={{ display: isSignUp ? "none" : "block" }}
          >
            <Formik
              initialValues={initialState}
              validationSchema={signInSchema}
              onSubmit={(values, action) => {
                handleLogin(values, action);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form className="d-flex">
                  <div className="mb-4">
                    <a
                      className="navbar-brand ct_logo_text position-absolute"
                      href="javascript:void(0)"
                      onClick={() => navigate(-1)}
                    >
                      <i className="fa-solid fa-arrow-left"></i> Back
                    </a>
                  </div>
                  <h1 className="mb-5">
                    Sign in to your combat robotics directory page
                  </h1>
                  <div className="ct_input-group mb-3">
                    <input
                      required
                      type="text"
                      name="email"
                      autoComplete="off"
                      className="ct_input"
                      id="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <label className="ct_user-label">
                      Email{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="email"
                    />
                  </div>
                  <div className="ct_input-group position-relative">
                    <input
                      required
                      type={!isEye ? "password" : "text"}
                      name="password"
                      autoComplete="off"
                      className="ct_input"
                      id="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    <Eye
                      isEye={isEye}
                      onClick={setIsEye}
                      style={{ top: "20px" }}
                    />
                    <label className="ct_user-label">
                      Password{" "}
                      <span className="ct_red_text d-inline-block">*</span>
                    </label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="password"
                    />
                  </div>
                  {/* <a
                    href="javascript:void(0)"
                    onClick={() => navigate(pageRoutes?.forgotPassword)}
                  >
                    Forgot password?
                  </a> */}
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-secondary ct_btn_animate w-100 mt-3"
                  >
                    Sign In
                  </button>
                </form>
              )}
            </Formik>
          </div>

          <div className="overlay-container">
            <div className="overlay">
              {/* Sign In Button */}
              <div className="overlay-panel overlay-left">
                <h1 className="text-white mb-3">Welcome Back!</h1>
                <p>To stay connected, please login with your personal info.</p>
                <button
                  className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  onClick={toggleSignUp}
                >
                  Sign In
                </button>
              </div>
              {/* Sign Up Button */}
              <div className="overlay-panel overlay-right">
                <h1 className="text-white mb-3">Hello, Friend!</h1>
                <p>
                  Enter your personal details and start your journey with us.
                </p>
                <button
                  className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  onClick={toggleSignUp}
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* persnal detail modal */}
      <Modal
        title={``}
        centered={true}
        className="w-100"
        style={{ maxWidth: "800px" }}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          navigate(pageRoutes.more?.teamDirectory);
        }}
        footer={null}
      >
        <div className="mt-4">
          <div
            class="modal-dialog modal-dialog-centered mx-0"
            style={{ maxWidth: "100%" }}
          >
            <div class="modal-content border-0">
              <div class="modal-body py-0">
                <h4 className="ct_fs_24 text-center mb-4">
                  Robot Combat Team Details
                </h4>
                <Formik
                  initialValues={{
                    ...initialState2,
                    name: user?.name,
                    email: user?.email,
                    number: user?.number,
                    designation: user?.designation,
                    website_link: user?.website_link,
                    discord_name: user?.discord_name,
                    about: user?.about,
                    password: user?.password,
                    confirm_password: user?.confirm_password,
                  }}
                  validationSchema={basicDetailSchema}
                  onSubmit={(values, actions) => {
                    handleUpdateMemberDetails(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    handleSubmit,
                  }) => (
                    <form
                      onSubmit={handleSubmit}
                      className="ct_free_account_overflow"
                      style={{ overflowX: "hidden" }}
                    >
                      {/* Upload photo input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Profile Image
                        </label>
                        <label for="ct_team_upload_img" className="d-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              setTouched({ profile_image: true });
                              setFieldValue("profile_image", file);
                            }}
                            onBlur={handleBlur}
                            className="form-control d-none"
                            id="ct_team_upload_img"
                          />
                          <div className="ct_team_upload_box_23">
                            <p className="text-center mb-0 ct_fs_18">
                              Upload Image here
                            </p>

                            {values?.profile_image && (
                              <img
                                src={
                                  typeof values.profile_image === "string"
                                    ? values.profile_image
                                    : URL.createObjectURL(values.profile_image)
                                }
                                className="ct_uploded_img"
                                alt="Uploaded Preview"
                              />
                            )}
                          </div>
                        </label>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="profile_image"
                        />
                      </div>
                      {/* Name Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Team Name <span className="ct_red_text">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter team name"
                          className="form-control"
                          value={values.name}
                          id="name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="name"
                        />
                      </div>
                      {/* Email Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Contact Email
                        </label>
                        <input
                          type="email"
                          placeholder="Enter contact email"
                          className="form-control"
                          value={values.email}
                          id="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="email"
                        />
                      </div>
                      {/* Number Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">Number</label>
                        <input
                          type="text"
                          placeholder="Enter number"
                          className="form-control"
                          value={values.number}
                          id="number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="number"
                        />
                      </div>
                      {/* Position Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Position
                        </label>
                        <input
                          type="text"
                          placeholder="Enter your position"
                          className="form-control"
                          value={values.designation}
                          id="designation"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="designation"
                        />
                      </div>
                      {/* Website link */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Website Link
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Website Link"
                          className="form-control"
                          value={values.website_link}
                          id="website_link"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="website_link"
                        />
                      </div>
                      {/* Discord Number */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Discord Name
                        </label>
                        <input
                          type="text"
                          placeholder="Enter discord name"
                          className="form-control"
                          value={values.discord_name}
                          id="discord_name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="discord_name"
                        />
                      </div>
                      {/*  Bot Directory */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Bot Directory
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            const selectedBot = filteredBotList.find(
                              (bot) => bot.id == e.target.value
                            );

                            setWeight_class_id(selectedBot?.weight_class?.id);
                            setBot_id(e.target.value);
                          }}
                          value={bot_id}
                        >
                          <option value="" disabled selected>
                            Select Bot
                          </option>
                          {filteredBotList?.map((bot) => (
                            <option key={bot.id} value={bot.id}>
                              {bot.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/*  Weight Classes */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Weight Classes
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            setWeight_class_id(e.target.value);
                          }}
                          value={weight_class_id}
                        >
                          <option value="" disabled selected>
                            Select Weight Class
                          </option>
                          {weightClassCategories?.map((item) => (
                            <option key={item.id} value={item.id} disabled>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/*  Primary League You Compete In */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Primary League You Complete In
                        </label>
                        <input
                          type="text"
                          placeholder="Enter enter primary league you complete in"
                          className="form-control"
                          value={values.tournament}
                          id="tournament"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="tournament"
                        />
                      </div>
                      {/* State Country City */}
                      <LocationDropdown
                        state={selectedLocation}
                        onChange={handleLocationChange}
                      />
                      {/* Password Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            required
                            type={!isEye3 ? "password" : "text"}
                            name="password"
                            placeholder="Enter password"
                            autoComplete="off"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                          />
                          <Eye isEye={isEye3} onClick={setIsEye3} />
                        </div>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="password"
                        />
                      </div>
                      {/* Confirm Password Input */}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Confirm Password
                        </label>
                        <div className="position-relative">
                          <input
                            required
                            type={!isEye4 ? "password" : "text"}
                            name="confirm_password"
                            placeholder="Enter confirm password"
                            autoComplete="off"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirm_password}
                          />
                          <Eye isEye={isEye4} onClick={setIsEye4} />
                        </div>

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="confirm_password"
                        />
                      </div>
                      {/* Description Input*/}
                      <div className="form-group mb-3">
                        <label className="mb-2 d-block ct_fw_600">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          rows={4}
                          placeholder="Enter Description"
                          value={values.about}
                          id="about"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />

                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="about"
                        />
                      </div>

                      {/* Submit & Skip button */}
                      <div className="text-center mt-4 mx-auto d-flex align-items-center gap-2 justify-content-center">
                        <button
                          type="button"
                          onClick={handleSubmit}
                          className="btn btn-secondary ct_btn_animate"
                        >
                          {" "}
                          Submit
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary ct_btn_animate ct_skip_btn_123"
                          onClick={() =>
                            navigate(pageRoutes.more?.teamDirectory)
                          }
                        >
                          {" "}
                          Skip
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MemberLogin;
